import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "no-mb" }, "Bent u het niet eens met een besluit of met de inhoud van een document? Dan kunt u hieronder een bezwaar indienen op het betreffende document waarin het besluit is vastgesteld.", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h3", null, "Contactgegevens", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, "Onderstaande contactgegevens zullen worden gebruikt voor de behandeling van dit bezwaar. Pas aan indien nodig.", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("Contactpersoon "),
  /*#__PURE__*/_createElementVNode("span", { class: "required-label" }, "*")
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("Telefoonnummer "),
  /*#__PURE__*/_createElementVNode("span", { class: "required-label" }, "*")
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("E-mailadres "),
  /*#__PURE__*/_createElementVNode("span", { class: "required-label" }, "*")
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h3", null, "Details", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("Onderwerp "),
  /*#__PURE__*/_createElementVNode("span", { class: "required-label" }, "*")
], -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("Document "),
  /*#__PURE__*/_createElementVNode("span", { class: "required-label" }, "*")
], -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_12 = { key: 0 }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("Omschrijving "),
  /*#__PURE__*/_createElementVNode("span", { class: "required-label" }, "*")
], -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("Velden gemarkeerd met een "),
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f38929"} }, "*"),
  /*#__PURE__*/_createTextVNode(" zijn verplicht.")
], -1)

import { useRouter } from 'vue-router'
import { objectionStore } from '@/stores/objection'
import TextEditor from '@/components/service/TextEditor.vue'
import { computed, onMounted, ref } from 'vue'
import { authStore } from '@/stores/auth'
import { NewObjection } from '@/types/service/objection'
import { generalStore } from '@/stores/general'


export default /*#__PURE__*/_defineComponent({
  __name: 'ObjectionCreate',
  setup(__props) {

const router = useRouter()
const objection = ref<NewObjection>({
  title: null,
  body: null,
  contact_name: authStore().user.fullname ?? null,
  contact_phone: authStore().user.phonenumber ?? null,
  contact_email: authStore().user.email ?? null,
  document_id: null,
  type: 2
})

const requiredFieldsCompleted = computed(() => {
  return !!(objection.value.title && objection.value.body && objection.value.contact_name && objection.value.contact_email && objection.value.contact_phone && objection.value.document_id)
})

onMounted(() => {
  objectionStore().getDocuments()
})

return (_ctx: any,_cache: any) => {
  const _component_a_alert = _resolveComponent("a-alert")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select_opt_group = _resolveComponent("a-select-opt-group")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createBlock(_component_a_row, { gutter: [16,16] }, {
    default: _withCtx(() => [
      (_unref(generalStore)().appSettings?.notification?.pages.includes('Service'))
        ? (_openBlock(), _createBlock(_component_a_col, {
            key: 0,
            xs: {span: 24},
            sm: {span: 24},
            md: {span: 24},
            lg: {span: 18, offset: 3}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_alert, {
                type: "info",
                class: "global-notification mb-16",
                message: _unref(generalStore)().appSettings.notification.title,
                "show-icon": ""
              }, {
                description: _withCtx(() => [
                  _createElementVNode("div", {
                    innerHTML: _unref(generalStore)().appSettings.notification.description
                  }, null, 8, _hoisted_1)
                ]),
                _: 1
              }, 8, ["message"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_a_col, {
        xs: {span: 24},
        sm: {span: 24},
        md: {span: 24},
        lg: {span: 18, offset: 3}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_card, { title: "Bezwaar indienen." }, {
            extra: _withCtx(() => [
              (_unref(generalStore)().desktop)
                ? (_openBlock(), _createBlock(_component_a_button, {
                    key: 0,
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push({ name: 'Service' })))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Terug naar service")
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            default: _withCtx(() => [
              _createVNode(_component_a_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, { span: 24 }, {
                    default: _withCtx(() => [
                      _hoisted_2
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _hoisted_3,
              _hoisted_4,
              _createVNode(_component_a_row, { gutter: [16,16] }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, {
                    xs: {span: 24},
                    sm: {span: 24},
                    md: {span: 24},
                    lg: {span: 12}
                  }, {
                    default: _withCtx(() => [
                      _hoisted_5,
                      _createVNode(_component_a_input, {
                        type: "text",
                        value: objection.value.contact_name,
                        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((objection.value.contact_name) = $event))
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_row, { gutter: [16,16] }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, {
                    xs: {span: 24},
                    sm: {span: 24},
                    md: {span: 24},
                    lg: {span: 12}
                  }, {
                    default: _withCtx(() => [
                      _hoisted_6,
                      _createVNode(_component_a_input, {
                        type: "text",
                        value: objection.value.contact_phone,
                        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((objection.value.contact_phone) = $event))
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, {
                    xs: {span: 24},
                    sm: {span: 24},
                    md: {span: 24},
                    lg: {span: 12}
                  }, {
                    default: _withCtx(() => [
                      _hoisted_7,
                      _createVNode(_component_a_input, {
                        type: "text",
                        value: objection.value.contact_email,
                        "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((objection.value.contact_email) = $event))
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_divider),
              _hoisted_8,
              _createVNode(_component_a_row, { gutter: [16,16] }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, {
                    xs: {span: 24},
                    sm: {span: 24},
                    md: {span: 24},
                    lg: {span: 12}
                  }, {
                    default: _withCtx(() => [
                      _hoisted_9,
                      _createVNode(_component_a_input, {
                        type: "text",
                        value: objection.value.title,
                        "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((objection.value.title) = $event))
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, {
                    xs: {span: 24},
                    sm: {span: 24},
                    md: {span: 24},
                    lg: {span: 12}
                  }, {
                    default: _withCtx(() => [
                      _hoisted_10,
                      _hoisted_11,
                      _createVNode(_component_a_select, {
                        style: {"width":"100%"},
                        value: objection.value.document_id,
                        "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((objection.value.document_id) = $event)),
                        loading: !_unref(objectionStore)().documents
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(objectionStore)().documents, (dir) => {
                            return (_openBlock(), _createBlock(_component_a_select_opt_group, {
                              key: dir.name
                            }, {
                              label: _withCtx(() => [
                                _createElementVNode("b", null, _toDisplayString(dir.name), 1)
                              ]),
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dir.documents, (doc) => {
                                  return (_openBlock(), _createBlock(_component_a_select_option, {
                                    value: doc.id,
                                    key: doc.id
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(doc.name), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["value"]))
                                }), 128))
                              ]),
                              _: 2
                            }, 1024))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["value", "loading"]),
                      (Array.isArray(_unref(objectionStore)().documents))
                        ? (_openBlock(), _createElementBlock("p", _hoisted_12, "Er zijn (nog) geen documenten waarop u bezwaar kunt maken."))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_row, { gutter: [16,16] }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, { span: 24 }, {
                    default: _withCtx(() => [
                      _hoisted_13,
                      _createVNode(TextEditor, {
                        content: objection.value.body,
                        onContentChange: _cache[6] || (_cache[6] = ($event: any) => (objection.value.body = $event))
                      }, null, 8, ["content"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_row, {
                class: "no-mb",
                gutter: [16,16]
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, { span: 24 }, {
                    default: _withCtx(() => [
                      _hoisted_14,
                      _createVNode(_component_a_button, {
                        type: "primary",
                        disabled: _unref(authStore)().restricted() || !_unref(requiredFieldsCompleted) || _unref(objectionStore)().loading,
                        loading: _unref(objectionStore)().loading,
                        onClick: _cache[7] || (_cache[7] = ($event: any) => (_unref(objectionStore)().storeObjection(objection.value)))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Bezwaar insturen")
                        ]),
                        _: 1
                      }, 8, ["disabled", "loading"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})